export class MachineAlertsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getAll(params) {
    return this.instance.get('/v1/machine-alerts/', { params });
  }

  getByMachineId(maquinaId) {
    return this.instance.get(`/v1/machine-alerts/maquina/${maquinaId}`);
  }

  getById(id) {
    return this.instance.get(`/v1/machine-alerts/${id}`);
  }

  create(maquinaId, data) {
    return this.instance.post(`/v1/machine-alerts/maquina/${maquinaId}`, data);
  }

  update(id, data) {
    return this.instance.put(`/v1/machine-alerts/${id}`, data);
  }

  concluir(id, data) {
    return this.instance.post(`/v1/machine-alerts/${id}/concluir`, data);
  }

  deleteById(id) {
    return this.instance.delete(`/v1/machine-alerts/${id}`);
  }
}

export default (...params) => new MachineAlertsFactory(...params);
